module.exports = __webpack_public_path__ + "static/img/materials13.c88165e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materials13.png
// module id = 2l9O
// module chunks = 2